// extracted by mini-css-extract-plugin
module.exports = {"close":"close__dHlmY","icon":"icon__2Vtdi"};